import { render, staticRenderFns } from "./RecibosDePoliza.vue?vue&type=template&id=11a69a45&"
import script from "./RecibosDePoliza.vue?vue&type=script&lang=js&"
export * from "./RecibosDePoliza.vue?vue&type=script&lang=js&"
import style0 from "./RecibosDePoliza.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports